
export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "",
  headLine: "Join Us",
  description:
    "eAlaga is proud to offer a great opportunity for job seekers in the Taguig area. Our mobile and web application makes it easy for applicants to apply for jobs at the Center for Elderly in Taguig. With our simple and straightforward process, applicants can quickly and easily submit their applications and get their applications processed quickly. We look forward to welcoming new applicants to the Taguig Center and helping them find their perfect job.",
  buttonLabel: 'Click Here',
  imgStart: true,
  img: require("../../../images/joinuss.gif"),

  alt: "Car",
  dark: true,
  primary: true,
  darkText: true
};


